export default __webpack_public_path__ + "static/media/foto_menu.31c26f6d.jpg";